// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/build/release-cloudweb-15005-130-1-1.202303300710/" + chunkId + ".js";
};